/**
 *
 * Asynchronously loads the component for ResetPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
